import * as React from "react";
import { WarningIcon } from "affinityIcons";

import { Tag, TagType } from "affinityUI/elements/tag";
import { PatientsListEntry } from "types/patient";

enum measurements {
  whiteBloodCells = "White Blood Cells",
  neutrophils = "Neutrophils",
  haemoglobin = "Haemoglobin",
  platelets = "Platelets",
}

export const WarningTag: React.FC<{ confirmatoryThreshold?: Maybe<number>; patient: PatientsListEntry }> = ({
  confirmatoryThreshold,
  patient,
}) => {
  const rangeWarnings = (Object.keys(measurements) as Array<keyof typeof measurements>)
    .filter(
      (measureName) => patient?.latestResult && patient?.latestResult[measureName].measurementInterval?.outOfRange
    )
    .map((measureName) => {
      const measurementValue = patient?.latestResult && patient?.latestResult[measureName].value;
      return (
        <Tag key={measureName} type={TagType.negative} dark data-testid={`${measureName}-interval-alert`}>
          {measurements[measureName]} {measurementValue} <WarningIcon />
        </Tag>
      );
    });
  const requireConfirmatoryTest = Boolean(patient.latestResult?.belowNeutrophilThreshold);
  const confirmatoryTestWarning = requireConfirmatoryTest ? (
    <Tag type={TagType.negative} dark data-testid="confirmatory-test-alert">
      Neutrophils ≤ {confirmatoryThreshold} <WarningIcon />
    </Tag>
  ) : null;

  if (confirmatoryTestWarning && rangeWarnings.length === 0) {
    return confirmatoryTestWarning;
  }
  if (rangeWarnings.length > 1 || confirmatoryTestWarning) {
    return (
      <Tag type={TagType.negative} dark data-testid="out-of-range-alert">
        Out of range <WarningIcon />
      </Tag>
    );
  }
  return rangeWarnings[0] ?? null;
};
